/**
 * «Зараз» для відносних дат («Сьогодні, 10:00», «Прострочено»): один таймер на вкладку,
 * оновлення раз на хвилину — без перерендеру списку щосекунди.
 */
import { useSyncExternalStore } from 'react';

let now = Date.now();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | undefined;

function subscribe(listener: () => void) {
  listeners.add(listener);
  timer ??= setInterval(() => {
    now = Date.now();
    for (const l of listeners) l();
  }, 60_000);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer) {
      clearInterval(timer);
      timer = undefined;
    }
  };
}

export function useNow(): number {
  return useSyncExternalStore(
    subscribe,
    () => now,
    () => now,
  );
}

/** «Зараз» інтерфейсу поза React: з ним звіряють, чи межа вже показана (`features/today/live.ts`). */
export const currentNow = () => now;

/**
 * Підписка на зміну «зараз» поза React — без перерендеру того, хто підписався (оболонка).
 * Підписка тримає щохвилинний таймер, як і `useNow`.
 */
export const onNowChange = subscribe;

/** Для тестів і після довгого сну вкладки. */
export function refreshNow() {
  now = Date.now();
  for (const l of listeners) l();
}
